import { render, staticRenderFns } from "./tpl-10.vue?vue&type=template&id=54ea1376&scoped=true&"
import script from "./tpl-10.vue?vue&type=script&lang=js&"
export * from "./tpl-10.vue?vue&type=script&lang=js&"
import style0 from "./tpl-10.vue?vue&type=style&index=0&id=54ea1376&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54ea1376",
  null
  
)

export default component.exports